import { createSlice } from "@reduxjs/toolkit";

const getClientsSlice = createSlice({
  name: "get client",
  initialState: { data: [] },
  reducers: {
    getClients: (state, action) => {
      state.data = action.payload;
    },
  },
});

export const { getClients } = getClientsSlice.actions;

export default getClientsSlice.reducer;
